import { Component, HostBinding } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CmsParagraphComponent } from "@spartacus/core";
import { CmsComponentData } from "@spartacus/storefront";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Component({
  selector: 'app-custom-paragraph',
  templateUrl: './custom-paragraph.component.html',
  standalone: false
})
export class CustomParagraphComponent {
  @HostBinding('class') styleClasses: string;

  data$: Observable<CmsParagraphComponent> = this.component?.data$?.pipe(
    tap((data) => (this.styleClasses = data?.styleClasses))
  );

  constructor(
    protected component: CmsComponentData<CmsParagraphComponent>,
    private sanitizer: DomSanitizer
  ) { }

  getHTML(html: string): any {
    const text = this.sanitizer.bypassSecurityTrustHtml(html);
    return text;
  }
}
